import { getApplicationSettings } from "owa-application-settings";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { logGreyError } from "owa-analytics";
import { getPresenceCloudConfig } from "../config/cloudConfig";

export function buildMriFromAADObjectId(aadObjectId?: string): string | undefined {
    if (!aadObjectId) {
        return undefined;
    }
    
    // MRI format doc: https://skype.visualstudio.com/SKYPECENTRAL/_wiki/wikis/SKYPECENTRAL.wiki/3055/Cloud-Specific-MRIs
    // The cloud-specific prefix is 'orgid' (WW), 'gcch' (GCCH), 'dod' (DOD).
    // Note: convertFromLegacyMRI (in presence/trouter/utils.ts) preserves the prefix when normalizing legacy MRI formats.
    const mailboxInfo = getModuleContextMailboxInfo();
    if (isAccountFeatureEnabled("msplaces-presence-resource-appsetting", mailboxInfo)) {
        try {
            // The `PresenceResource` setting's mriPrefix already includes the '8:' segment (e.g. '8:orgid').
            const mriPrefix = getApplicationSettings("PresenceResource", mailboxInfo).mriPrefix;
            if (typeof mriPrefix === "string" && mriPrefix.length > 0) {
                return `${mriPrefix}:${aadObjectId}`;
            }
        }
        catch {
            logGreyError("PresenceApplicationSettingError", mailboxInfo);
        }
    }
    return `8:${getPresenceCloudConfig().mriOrgSegment}:${aadObjectId}`;
}
